<template>
  <div class="button-container"><el-button class="welcome-button" v-if="!authStore.isLoggedIn" type="primary" @click="authStore.login">Login</el-button></div>
  <div class="welcome-container">
    
    <h1 class="welcome-title">{{ t('appleFarm.title') }}</h1>
    <img src="../assets/logo.svg" alt="Apple Farm" class="welcome-image">
    <p class="welcome-about">{{ t('appleFarm.about') }}</p>
    <p class="welcome-about">{{ t('appleFarm.apples') }}</p>
  </div>
  
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '../stores/auth'
import { useRouter } from 'vue-router'

const authStore = useAuthStore()
const router = useRouter()
const { t } = useI18n()

if (authStore.isLoggedIn) {
  router.push('/')
}
</script>

<style scoped>
.welcome-button {
  margin-top: 1rem;
  margin-bottom: 1rem;
  justify-content: right;
  margin-right: 1rem;
}

.welcome-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.welcome-image {
  width: 60%;
  margin-bottom: 1rem;
}

.welcome-title {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 1rem;
}

.welcome-about {
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.welcome-apples {
  text-align: center;
  font-size: 1rem;
  margin-bottom: 1rem;
}

.button-container {
  display: flex;
  justify-content: right;
  width: 100%;
}
</style> 